function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.802 8.4a1 1 0 01.2.6v4.382l1-.5V9a1 1 0 01.2-.6l4.8-6.4h-11l4.8 6.4zm-7.6-6.8a1 1 0 01.8-1.6h15a1 1 0 01.8 1.6l-5.8 7.733V13.5a1 1 0 01-.553.894l-3 1.5A1 1 0 016.002 15V9.333L.202 1.6z"
});

function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16"
  }, props), _ref);
}

export default SvgFilter;